import { render, staticRenderFns } from "./manageMC.vue?vue&type=template&id=336cd311"
import script from "./manageMC.vue?vue&type=script&lang=js"
export * from "./manageMC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports